import { Component, OnInit } from '@angular/core';
import { OtEventService } from '../ot-event.service';
import { ActivatedRoute, Router } from '@angular/router';
import { City, Teacher } from 'src/app/domain/ot-event';
import { OtCityService } from '../ot-city.service';
import { TeacherProfileComponent } from 'src/app/shared';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OtSessionService } from '../ot-session.service';

@Component({
  selector: 'app-ot-event-list',
  templateUrl: './ot-event-list.component.html',
  styleUrls: ['./ot-event-list.component.scss']
})
export class OtEventListComponent implements OnInit {

  public cityId: number;
  public otEventInfoList: Object[];
  public city: City;

  constructor(
      private otEventService: OtEventService,
      private cityService: OtCityService,
      private modalService: NgbModal,
      private router: Router,
      private otSessionService: OtSessionService,
      route: ActivatedRoute) {
    this.cityId = Number.parseInt(route.snapshot.paramMap.get('cityId'), 10);
  }

  ngOnInit() {
    this.cityService.getById(this.cityId).then(city => {
      this.city = city;
    });
    this.otEventService.findByCityId(this.cityId).then(otEventInfoList => {
      this.otEventInfoList = otEventInfoList;
    });
  }

  public showTeacherProfile(teacher: Teacher): void {
    const modalRef = this.modalService.open(TeacherProfileComponent);
    modalRef.componentInstance.teacher = teacher;
  }

  goToNextStep(otEventInfo): void {
    if (!otEventInfo.otEvent.pricing) {
      this.otSessionService.setRegistration({
        happeningId: otEventInfo.otEvent.id,
        happening: {
          id: otEventInfo.otEvent.id,
          happeningTypeCode: 'OT_EVENT'
        },
        otEvent: otEventInfo.otEvent
      });
      this.router.navigateByUrl('/city/' + this.cityId + '/ot/event/' + otEventInfo.otEvent.id + '/registration/person');
    } else {
      this.router.navigate(['/city/' + this.cityId + '/ot/event/' + otEventInfo.otEvent.id + '/registration/price'])
    }
  }
}
